export default function ComparisonSection() {
  const platforms = [
    {
      name: 'YOYBUY Spreadsheet',
      price: 'Низкая',
      speed: 'Средняя',
      reliability: 'Высокая',
      audience: 'Новички + бизнес',
      highlight: true,
      color: 'primary',
    },
    {
      name: 'Kakobuy Spreadsheet',
      price: 'Средняя',
      speed: 'Высокая',
      reliability: 'Средняя',
      audience: 'Продвинутые',
      highlight: false,
      color: 'secondary',
    },
    {
      name: 'Superbuy Spreadsheet',
      price: 'Высокая',
      speed: 'Очень высокая',
      reliability: 'Очень высокая',
      audience: 'Профессионалы',
      highlight: false,
      color: 'accent',
    },
  ];

  return (
    <section id="comparison" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em]">Сравнение платформ</span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
              Выберите лучшую<br />платформу для закупок
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            Сравните три ведущие платформы для закупок из Китая.
            Каждая система имеет свои преимущества — выберите ту, что подходит именно вам.
          </p>
        </div>

        {/* Platform cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {platforms.map((platform) => (
            <div
              key={platform.name}
              className={`relative rounded-2xl p-6 md:p-8 flex flex-col gap-5 transition-all duration-300 ${
                platform.highlight
                  ? 'bg-foreground-900 border border-foreground-800'
                  : 'bg-background-50 border border-background-200 hover:border-background-300'
              }`}
            >
              {platform.highlight && (
                <span className="absolute -top-3 left-6 px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                  Рекомендуем
                </span>
              )}

              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${
                platform.highlight ? 'bg-primary-500/20' : 'bg-background-100'
              }`}>
                <i className={`ri-database-2-line text-xl ${
                  platform.highlight ? 'text-primary-400' : 'text-foreground-500'
                }`}></i>
              </div>

              <h3 className={`text-xl font-heading font-bold ${
                platform.highlight ? 'text-background-50' : 'text-foreground-900'
              }`}>
                {platform.name}
              </h3>

              <div className="flex flex-col gap-3">
                {[
                  { label: 'Цена', value: platform.price },
                  { label: 'Скорость', value: platform.speed },
                  { label: 'Надёжность', value: platform.reliability },
                  { label: 'Для кого', value: platform.audience },
                ].map((row) => (
                  <div key={row.label} className="flex items-center justify-between py-2 border-b border-foreground-800/10 last:border-0">
                    <span className={`text-xs font-medium ${
                      platform.highlight ? 'text-foreground-400' : 'text-foreground-500'
                    }`}>{row.label}</span>
                    <span className={`text-xs font-semibold ${
                      platform.highlight ? 'text-background-50' : 'text-foreground-800'
                    }`}>{row.value}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className={`mt-auto px-5 py-2.5 rounded-full text-sm font-semibold text-center transition-all whitespace-nowrap cursor-pointer ${
                  platform.highlight
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                }`}
              >
                Перейти
              </a>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-xs text-foreground-400 mt-8 max-w-lg mx-auto">
          Данные основаны на отзывах пользователей и актуальны на 2026 год.
          Все платформы поддерживают экспорт в формат spreadsheet.
        </p>
      </div>
    </section>
  );
}